"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadianceAbilityHandler = exports.RadianceActorAbilityFactory = exports.RadianceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class RadianceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Radiance;
        this.__typeName = "Radiance";
    }
}
exports.RadianceAbilityArgs = RadianceAbilityArgs;
let RadianceActorAbilityFactory = class RadianceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Radiance", "Self", 0);
    }
};
RadianceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Radiance")
], RadianceActorAbilityFactory);
exports.RadianceActorAbilityFactory = RadianceActorAbilityFactory;
let RadianceAbilityHandler = class RadianceAbilityHandler {
    init(sequence, container, actorId) {
        const additionalEffects = Array.of();
        if (container.hasAttribute(actorId, "Charm_Sunbreaker_0")) {
            additionalEffects.push(new __1.LinkedEventHandlerEffectArgs("Improved Radiance", "Removes a random debuff from each ally when damage is dealt", false, container.registerEventHandler(actorId, __1.EventType.DamageDealt, __1.Schedule.Unlimited, new __1.DispatchActionEventHandlerArgs(new __1.RemoveRandomDebuffActionArgs(), Target_1.Target.AllAllies))));
        }
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new __1.LinkedEffectsEffectArgs([
                new __1.RadianceEffectArgs(3),
            ], false),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
RadianceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Radiance)
], RadianceAbilityHandler);
exports.RadianceAbilityHandler = RadianceAbilityHandler;
